// extracted by mini-css-extract-plugin
module.exports = {"rating":"_5zb73l","hasHalfStar":"_3z8XjA","one":"_3paGWP","two":"eQC7-R","three":"_2VCejb","four":"_1fDc9n"};